import { Tabs } from '@mui/material'
import { StyledTab } from 'components/StyledTab/StyledTab'
import TabPanel from 'components/TabPanel/TabPanel'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { selectRobot } from 'store/selectors/robot'
import { VENDOR } from 'utils/vendorDisplayName'

import RobotControl from './RobotControl/RobotControl'
import RobotDetails from './RobotDetails/RobotDetails'
import RobotTasks from './RobotTasks/RobotTasks'
import Service from './Service/Service'

const RobotLeftBlock = () => {
  const { t } = useTranslation()
  const robot = useSelector(selectRobot)
  const isGausium = robot.robotInfo?.vendor === VENDOR.GAUSIUM
  const [tab, setTab] = useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue)
  }

  const detailsIndex = 0
  const controlIndex = 1
  const serviceIndex = 2
  const tasksIndex = isGausium ? 2 : 3

  return (
    <div className="flex-column">
      <Tabs
        value={tab}
        onChange={handleChange}
        variant="fullWidth"
        indicatorColor="primary"
        sx={{ height: 45, minHeight: 45 }}
      >
        <StyledTab
          label={t('robot.details')}
          sx={{ fontSize: 16, fontWeight: '400', textTransform: 'none', letterSpacing: 0, maxWidth: 185 }}
          disableRipple
        />
        <StyledTab
          label={t('robot.control')}
          sx={{ fontSize: 16, fontWeight: '400', textTransform: 'none', letterSpacing: 0, maxWidth: 185 }}
          disableRipple
        />
        {!isGausium && (
          <StyledTab
            label={t('robot.service')}
            sx={{ fontSize: 16, fontWeight: '400', textTransform: 'none', letterSpacing: 0, maxWidth: 185 }}
            disableRipple
          />
        )}
        <StyledTab
          label={t('robot.tasks')}
          sx={{ fontSize: 16, fontWeight: '400', textTransform: 'none', letterSpacing: 0, maxWidth: 185 }}
          disableRipple
        />
      </Tabs>
      <TabPanel value={tab} index={detailsIndex} disablePadding={true}>
        <RobotDetails />
      </TabPanel>
      <TabPanel value={tab} index={controlIndex} disablePadding={true}>
        <RobotControl />
      </TabPanel>
      {!isGausium && (
        <TabPanel value={tab} index={serviceIndex} disablePadding={true}>
          <Service />
        </TabPanel>
      )}
      <TabPanel value={tab} index={tasksIndex} disablePadding={true}>
        <RobotTasks />
      </TabPanel>
    </div>
  )
}

export default RobotLeftBlock
